import React from "react";
import { useNavigate } from "react-router-dom";
import HomeMobileCard from "./HomeMobileCard";
import PhoneCardDesign01 from "../Assets/mockup-design/sejiwa_mockup_ex1.png"
import PhoneCardDesign02 from "../Assets/mockup-design/sejiwa_mockup_ex2.png"
import PhoneCardDesign03 from "../Assets/mockup-design/sejiwa_mockup_ex3.png"
import PhoneCardDesign04 from "../Assets/mockup-design/sejiwa_mockup_ex4.png"
import { Box, Typography, Button, Container, useMediaQuery, useTheme } from "@mui/material";



const HomeMobileCardLayout = () => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Detect tablet
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();
  const designs = [
    {
      id: "FLORAL 004",
      image: PhoneCardDesign01,
      link: "https://www.sejiwa-my.com/design-preview/floral-004"
    },
    {
      id: "FLORAL 012",
      image: PhoneCardDesign02,
      link: "https://www.sejiwa-my.com/design-preview/floral-012"
    },
    {
      id: "CLOY",
      image: PhoneCardDesign03,
      link: "https://www.sejiwa-my.com/design-preview/kdrama-002"
    },
    {
      id: "FLORAL 005",
      image: PhoneCardDesign04,
      link: "https://www.sejiwa-my.com/design-preview/floral-005"
    }
  ];

  console.log("Container styles:", {
    px: isMobile ? "30px" : isTablet ? "40px" : "0px",
  });

  return (
    <Container sx={{ px: isMobile ? "30px" : isTablet ? "40px !important" : "", justifyItems: isDesktop ? "center" : "", textAlign: "center", py: 0, mt: isMobile ? 3 : 6 }}>
      <Typography variant="h6" fontWeight={600}>
        Top Pick Design
      </Typography>

      <Typography variant="body1" color="text.secondary" mb={4}>
        get your digital wedding card now...
      </Typography>

      <Box sx={{
        display: 'flex',
        overflowX: 'auto',
        gap: isMobile ? 3 : 4,
        pb: 3,
        scrollbarWidth: 'auto',
        '&::-webkit-scrollbar': { height: '8px' },
        '&::-webkit-scrollbar-thumb': { background: '#ccc', borderRadius: '10px' },
        '&::-webkit-scrollbar-track': { background: '#eee' } // Optional: change track color
      }}>
        {designs.map((design, index) => (
          <Box key={index} sx={{ flex: '0 0 auto' }}>
            <HomeMobileCard id={design.id} image={design.image} link={design.link} />
          </Box>
        ))}
      </Box>

      <Box mt={2}>
        <Button onClick={() => navigate("/catalog")} variant="contained" disableElevation sx={{ textTransform: "none", backgroundColor: "#68D2D2", borderRadius: 50 }}>
          See More
        </Button>
      </Box>
    </Container>
  );
};

export default HomeMobileCardLayout;
